var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('dark-theme',[_vm._t("default"),_c('dark-footer')],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }